import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { ErrMessage } from './style';
const ErrorMessage = ({ errorMessage, className, errorTestId = 'input-error', }) => {
    const { colors } = useTheme();
    return errorMessage ? (_jsx(ErrMessage, { className: className, color: colors.text.critical, type: "caption", fontFamily: "primary", testId: errorTestId, children: errorMessage })) : null;
};
export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map